import { useDispatch } from "react-redux";
import { ACTIONS } from "src/_config";

export function useAppEventAction() {
  const dispatch = useDispatch();

 
  const updateReferrerUrl = (data?: any) => {
    dispatch({
      type: ACTIONS.COMMON.REFFERER_URL,
      payload: data,
    });
  };

  return {
    updateReferrerUrl,
  };
}
